var Blog = {};

//--------------
// Variables
//--------------

Blog.$blogSwiper = $('.js-blog-swiper');


//--------------
// Functions
//--------------

/**
 * Init Blog Swiper
 * @return {void}
 */
Blog.initBlogSwiper = function(){
  var blogSwiper = new Swiper('.js-blog-swiper', {
    loop: true,
    speed: 1000,
    allowTouchMove: false,

    // Navigation arrows
    navigation: {
      nextEl: '.js-blog-swiper-button-next',
      prevEl: '.js-blog-swiper-button-prev',
    },
    pagination: {
      el: '.js-blog-swiper-pagination',
      type: 'bullets',
      clickable: 'true'
    },
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    breakpoints: {
      991: {
        allowTouchMove: true,
      }
    },
  });
}

/**
 * Init blog scripts
 * @return {[type]} [description]
 */
Blog.init = function(){
	Blog.$blogSwiper = $('.js-blog-swiper');
	
	//-- Init Blog Carousel
  if(Blog.$blogSwiper.length > 0) {
    Blog.initBlogSwiper();
  }

  if($('video').length > 0){
  	$('video')[0].play();
  }
}

/**
 * Destroy blog scripts
 * @return {void}
 */
Blog.destroy = function(){

}

//--------------
// Execution
//--------------

module.exports = Blog;